import React from 'react';
/**
 * SVG with 3 vertical dots.
 *
 * @example
 * <MenuIcon  />
 */
export default function MenuIcon() {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "18", cy: "12", r: "1.5", fill: "currentColor" }),
        React.createElement("circle", { cx: "12", cy: "12", r: "1.5", fill: "currentColor" }),
        React.createElement("circle", { cx: "6", cy: "12", r: "1.5", fill: "currentColor" })));
}
//# sourceMappingURL=MenuIcon.js.map